import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Icon } from '../Icon/Icon.js';

var _excluded = ["closeText"];
var HeaderOriginationCloseButton = props => {
  var {
      closeText = 'Close'
    } = props,
    restprops = _objectWithoutProperties(props, _excluded);
  var closeIconContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "close-label"
  }, closeText), /*#__PURE__*/React.createElement(Icon, {
    type: "svginline",
    symbol: "controlClose24",
    iconClassName: "close-icon"
  }));
  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, restprops), !props.closeText && {
    'aria-label': 'Close'
  }), {}, {
    className: 'icon-wrapper headerorigination-close'
  });
  if (props.href) {
    attributes.href = props.href;
    return /*#__PURE__*/React.createElement("a", attributes, closeIconContent);
  }
  if (typeof props.onClick !== 'undefined') {
    attributes.onClick = props.onClick;
    attributes.type = 'button';
    return /*#__PURE__*/React.createElement("button", _extends({}, attributes, {
      type: "button"
    }), closeIconContent);
  }
  return null;
};
HeaderOriginationCloseButton.propTypes = {
  closeText: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func
};

export { HeaderOriginationCloseButton };
